<template>
	<div class="send-tokens-modal">
		<FullBackdrop class="fenif-test">
			<div class="container success" v-if="tokensSended">
				<h3 class="modal-title">{{$t('tokens_modal.title_success')}}</h3>
				<div class="message_tokens">{{$t('tokens_modal.descripcion_success')}}</div>
				<div class="tokens_quantity">{{tokensSendedQuantity}} Tokens</div>
				<div class="footer">
					<button class="cancel" @click="cancelHandler">{{$t('tokens_modal.button_back')}}</button>
				</div>
			</div>
			<div class="container spinner" v-if="sendingLoading">
				<Spinner />
			</div>
			<div class="container" v-if="!notEnoughTokens && !sendingLoading && !tokensSended">
				<h3 class="modal-title">{{$t('tokens_modal.title_send_tokens')}}</h3>
				<div class="form-input">
					<div style="margin-top:1rem;font-weight: bold;text-transform: uppercase;">Tokens Disponibles: <template v-if="balanceLoaded">{{balance}}</template></div>
				</div>
				<div class="form-input">
					<fieldset>
	    				<legend>{{$t('tokens_modal.quantity')}}</legend>
						<input type="number" name="tokens" :min="minTokens" v-model="sendTokensForm.tokens" />
					</fieldset>
					<template v-if="$v.sendTokensForm.tokens.$error">
              <p
                  class="error-message"
                  v-if="!$v.sendTokensForm.tokens.required"
              >
                  {{$t('validations.required', {field: $t('fields.tokens')})}}
              </p>
              <p
                  class="error-message"
                  v-if="!$v.sendTokensForm.tokens.minValue"
              >
                  {{$t('validations.minValue', {field: $t('fields.tokens'), minValue: minTokens})}}
              </p>
              <p
                  class="error-message"
                  v-if="!$v.sendTokensForm.tokens.integer"
              >
                  {{$t('validations.integer', {field: $t('fields.tokens')})}}
              </p>
          </template>
				</div>
				<div class="footer">
					<button class="cancel active" @click="cancelHandler">{{$t('tokens_modal.button_cancel')}}</button>
					<button @click="sendTokensHandler">{{$t('tokens_modal.button_send')}}</button>
				</div>
			</div>
			<div class="container" v-if="notEnoughTokens">
				<h3 class="modal-title" style="color:red;">{{$t('tokens_modal.title_not_enough_tokens')}}</h3>
				<p style="font-weight: bold;font-size: 1.2rem;text-transform: uppercase;">{{$t('tokens_modal.description_not_enought_tokens')}}</p>
				<div class="footer">
					<button class="cancel active" @click="cancelHandler">{{$t('tokens_modal.button_back')}}</button>
					<router-link
						class="action"
						:to="{ name: 'purchase.tokens' }"
					>
						<button>{{$t('tokens_modal.button_buy_tokens')}}</button>
					</router-link>
				</div>
			</div>
		</FullBackdrop>
	</div>
</template>
<script>
import FullBackdrop from "./FullBackdrop";
import {
  required,
  minValue,
  maxLength,
  integer,
} from "vuelidate/lib/validators";
import Spinner from "../components/Spinner";
import resources from "../resources";

export default {
  components: { FullBackdrop, Spinner },
  data() {
    return {
      notEnoughTokens: false,
      sendingLoading: false,
      tokensSended: false,
      balanceLoaded: false,
      minTokens: process.env.VUE_APP_TOKENS_MIN_TOKEN,
      maxMessage: 200,
      sendTokensForm: {
        tokens: "",
        message: "",
      },
      tokensSendedQuantity: 0,
      balance: 0,
    };
  },
  methods: {
    cancelHandler() {
      this.$emit("cancel");
      this.tokensSended = false;
    },
    sendTokensHandler() {
      if (this.$v.sendTokensForm.$invalid) {
        return this.$v.sendTokensForm.$touch();
      }
      this.sendingLoading = true;

      resources.videoCallRoom.storeAt({
        'id': this.$route.params.hash+'/send_tokens',
        quantity: this.sendTokensForm.tokens,
      }).then((response) => {
          if (response.data == "ok") {
            this.tokensSended = true;
            this.tokensSendedQuantity = this.sendTokensForm.tokens;
            this.$emit("tokensSended", this.sendTokensForm.tokens);
          }
          this.sendingLoading = false;
          this.sendTokensForm = {
            tokens: this.minTokens,
            message: "",
          };
        })
        .catch((err) => {
          if (err.data.error && err.data.error == "Not enough tokens") {
            this.notEnoughTokens = true;
          }
          this.sendingLoading = false;
        });
    },
    getTokensBalance() {
      resources.tokensBalance.index({}).then((response) => {
        this.balance = response.data.data.balance;
        this.balanceLoaded = true;
      });
    },
  },
  validations() {
    return {
      sendTokensForm: {
        tokens: {
          required,
          minValue: minValue(this.minTokens),
          integer,
        },
        message: {
          maxLength: maxLength(this.maxMessage),
        },
      },
    };
  },
  mounted() {
    this.getTokensBalance();
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/variables";
@import "../styles/classes";

.send-tokens-modal {
  & .spinner {
    align-items: center;
    display: flex;
    min-width: 300px;
    min-height: 300px;
    justify-content: center;
  }

  & .picture {
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #ffffff;
    border-radius: 50%;
    border: 3px solid var(--pallete_main_color);
  }

  & .verified {
    height: 1.2rem;
    width: 1.2rem;
    margin-left: 0.5rem;
  }

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .form-input {
      margin: 0.5rem 0;

      & .error-message {
        color: var(--pallete_main_color);
        font-size: 0.9rem;
        padding: 0.3rem;
        margin: 0;
      }
    }

    & .footer {
      display: flex;
      justify-content: end;


      & button {
        @extend %secondary-btn;
      }

      & button,
      .action {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }

      & button.cancel {
        @extend %fresh-btn;

        border-radius: 0.5rem;
      }
    }

    & label {
      box-sizing: border-box;
      font-weight: bold;
      padding: 0 1rem 0 0;
    }

    & textarea {
      border: none;
      max-width: 100%;
      min-width: 100%;
      padding: 0.3rem 0.5rem 0.8rem 0.5rem;
      font-size: 1rem;
    }

    & textarea:focus {
      border: transparent;
      outline: none;
    }

    & input {
      border: none;
      border-radius: 1rem;
      font-size: 1rem;
      padding: 0.3rem 0.5rem 0.8rem 0.5rem;
      width: 100%;
    }

    & input:focus {
      border: transparent;
      outline: none;
    }

    & fieldset {
      border-color: #ffffff7d;
      border-radius: 0.5rem;
      padding: 0;
      margin-top: 1.5rem;

      & legend {
        color: #767676;
        font-size: 1rem;
        margin-left: 0.3rem;
        font-weight: bold;
        text-transform: uppercase;
      }
    }

    & fieldset:has(> input:focus),
    & fieldset:has(> textarea:focus) {
      border-color: var(--pallete_main_color);
    }
  }

  & .success {
    text-align: center;

    & h3 {
      color: green;
    }

    & .picture {
      height: 6rem;
      width: 6rem;
    }

    & .cancel {
      font-size: 1.2rem;
      font-weight: bold;
    }

    & .footer {
      justify-content: center;
      margin-top: 1rem;
    }

    & .name {
      font-size: 1.2rem;
      text-transform: uppercase;
      padding: 0 0.5rem;
      font-weight: bold;
    }

    & .username {
      padding: 0 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0.3rem 0;

      & .verified {
        height: 1rem;
        width: 1rem;
        margin-left: 0.2rem;
      }
    }

    & .message_tokens {
      font-size: 1.5rem;
      font-weight: bold;
      margin: 1rem 0 0.5rem 0;
      text-transform: uppercase;
    }

    & .tokens_quantity {
      font-size: 2.5rem;
      color: red;
      font-weight: bold;
    }
  }

  & .user-card {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-evenly;

    & .name {
      font-size: 1.2rem;
      text-transform: uppercase;
      padding: 0 0.5rem;
      font-weight: bold;
      display: flex;
    }
  }
}
</style>
